var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabs)?_c('div',{attrs:{"id":"tab-user"}},[(_vm.tipe_project == 1)?_c('tab-vertical-component',{attrs:{"tabs":_vm.tabs}}):_c('keyword-kabayan')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }